import { IResourceManager } from '@cgs/common';
import { FreeSpinsInfoEvent, BonusResponse } from '@cgs/data-access';
import { BonusResourceManager } from '@cgs/features';
import { Container } from '@cgs/wge';
import { BaseMiniGameProvider } from './base_mini_game_provider';
import { GameStateMachineStates } from '../../../reels_engine/state_machine/game-state-machine-states';

export class BonusGameProvider extends BaseMiniGameProvider {
  constructor(
    container: Container,
    hideSlot: boolean = true,
    hideHud: boolean = true,
    gameTypes: string[] | null = null,
    externalScenesIds: string[] | null = null,
    gameTypeToBonusId: Map<string, string> | null = null
  ) {
    super(
      container,
      GameStateMachineStates.Bonus,
      hideSlot,
      hideHud,
      gameTypes,
      externalScenesIds,
      gameTypeToBonusId
    );
  }

  get bonusResponse(): BonusResponse | null {
    return this.stateMachine.curResponse.bonusInfo;
  }

  get resourceManager(): IResourceManager {
    return new BonusResourceManager(this.sceneCommon.sceneFactory);
  }

  onMiniGameStarted(): void {
    if (this.dynamicDrawOrdersProvider) {
      this.dynamicDrawOrdersProvider.showHudUnderBonus();
      this.dynamicDrawOrdersProvider.showBonusUnderMachine();
      this.dynamicDrawOrdersProvider.showBonusUnderContests();
    }
  }

  async onMiniGameFinished(): Promise<void> {
    this.stateMachine.resume();
  }

  async onMiniGameFinishing(): Promise<void> {
    if (
      this.stateMachine.curResponse.isFreeSpins &&
      this.stateMachine.curResponse.freeSpinsInfo &&
      this.stateMachine.curResponse.freeSpinsInfo.event !== FreeSpinsInfoEvent.FreeSpinsStarted
    ) {
      this.stateMachine.curResponse.freeSpinsInfo.totalWin +=
        this.bonusGame!.bonusResponse.result!.totalWin;
      this.stateMachine.curResponse.totalWin = this.bonusGame!.bonusResponse.result!.totalWin;
    }
    this.stateMachine.curResponse.bonusInfo = null;
    if (this.stateMachine.curResponse.winPositions) {
      this.stateMachine.curResponse.winPositions = this.removeWinIcons(
        this.stateMachine.curResponse.winPositions,
        ['bonus', 'bonusWild']
      );
    }

    // await tryActivateParleyProgress();

    this.dynamicDrawOrdersProvider?.normalizeDrawOrders();
  }
}
